import React from 'react'
import { Dropdown, DateInput, Button, TextInputOld, Container, Row, Col, IDropdownItem } from '@doseme/cohesive-ui'

import { IChangedSubscription } from '../../types/subscription'
import { TDateInputName } from '../../scenes/Dashboard/HospitalsPage/SubscriptionsEdit/SubscriptionsEdit'
import { ILabelWithValue } from './types'

import './index.scss'

interface IProps {
  loading: boolean
  hasChronologicalError: boolean
  selectedId: string | null
  selectedSub: IChangedSubscription
  planList: ILabelWithValue[]
  formValid: boolean
  onPlanSelect: (item: IDropdownItem) => void
  handleInput: (field: TDateInputName, value: string, valid: boolean) => void
  handleCancel: () => void
  handleSubmit: () => void
}

const SubscriptionsInputModal: React.FC<IProps> = ({
  loading,
  hasChronologicalError,
  selectedId,
  selectedSub,
  planList,
  formValid,
  onPlanSelect,
  handleInput,
  handleCancel,
  handleSubmit
}) => {
  const planDropdown = (): JSX.Element => {
    const idString = selectedSub.planId.toString()
    if (selectedId) {
      // IE does not support findIndex
      return (
        <TextInputOld
          name='plan'
          placeholder='Select Plan'
          label='Select Plan'
          defaultValue={idString}
          type='text'
          isRequired
          disabled
        />
      )
    }

    return (
      <Dropdown
        fieldState='valid'
        label='Select Plan'
        placeholder='Select Plan'
        data={planList}
        showSearchThreshold={0}
        value={idString}
        onSelect={onPlanSelect}
      />
    )
  }

  const error = hasChronologicalError && (
    <div className='d-flex justify-content-end warning'>Start date must be before end date.</div>
  )

  return (
    <div data-testid='subscriptions-modal' className='subscriptions-modal'>
      <Container>
        <h4 className='co-h4'>{selectedSub.id ? 'Edit Subscription' : 'Add New Subscription'}</h4>
        <br />

        {planDropdown()}
        <br />

        <DateInput
          name='startDate'
          label='Start Date'
          dateNotInPast
          defaultValue={selectedSub.start ? selectedSub.start.format('YYYY-MM-DD') : ''}
          disabled={!!selectedSub.id}
          handleBlur={(value, valid) => handleInput('start', value, valid)}
          data-testid='startDate'
        />
        <br />

        <DateInput
          name='endDate'
          label='Expiry Date'
          dateNotInPast
          defaultValue={selectedSub.end ? selectedSub.end.format('YYYY-MM-DD') : ''}
          handleBlur={(value, valid) => handleInput('end', value, valid)}
          data-testid='endDate'
        />
        <br />

        {error}

        <Row className='buttons'>
          <Col>
            <div className='d-flex justify-content-end'>
              <Button data-testid='confirm-modal-cancel' variant='primary' onClick={handleCancel}>
                Cancel
              </Button>
              <Button type='button' variant='secondary' onClick={handleSubmit} disabled={!formValid} loading={loading}>
                {selectedSub.id ? 'Update Subscription' : 'Add Subscription to Hospital'}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export { SubscriptionsInputModal }
